module.exports = __webpack_public_path__ + "img/truck-plow.2d1783bb.svg";